const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

export const isValidContactEmail = (email) => {
  const value = String(email || '').trim()
  return value.length > 0 && EMAIL_PATTERN.test(value)
}

/**
 * @param {Record<string, string>} form
 * @returns {Record<string, string>}
 */
export const validateContactForm = (form) => {
  const errors = {}
  const name = String(form.name || '').trim()
  const email = String(form.email || '').trim()
  const subject = String(form.subject || '').trim()
  const message = String(form.message || '').trim()

  if (name.length < 2) {
    errors.name = 'Bitte geben Sie Ihren Namen ein (mindestens 2 Zeichen).'
  }

  if (!email) {
    errors.email = 'Bitte geben Sie Ihre E-Mail-Adresse ein.'
  } else if (!isValidContactEmail(email)) {
    errors.email = 'Bitte geben Sie eine gültige E-Mail-Adresse ein.'
  }

  if (!subject) {
    errors.subject = 'Bitte geben Sie einen Betreff ein.'
  }

  if (message.length < 6) {
    errors.message = 'Bitte geben Sie eine Nachricht ein (mindestens 6 Zeichen).'
  }

  return errors
}

export const isContactFormValid = (form) =>
  Object.keys(validateContactForm(form)).length === 0
